/**
 * Parallel Clinic, kiosk route.
 *
 * Top-level (outside `_authenticated`) because the patient never logs in.
 * Authentication is handled inside KioskShell via the kiosk JWT (set from
 * the ``?token=`` query param at first hit, then persisted in
 * sessionStorage).
 *
 * If the token is missing or invalid the shell rejects on its first state
 * fetch and renders the "session expired" panel.
 */
import { createFileRoute } from '@tanstack/react-router';
import { KioskShell } from '../pages/Kiosk/KioskShell';

interface KioskSearch {
  token?: string;
}

export const Route = createFileRoute('/kiosk/$encounterId')({
  validateSearch: (search: Record<string, unknown>): KioskSearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: KioskRouteComponent,
});

function KioskRouteComponent() {
  const { encounterId } = Route.useParams();
  const { token } = Route.useSearch();
  return <KioskShell encounterId={encounterId} initialToken={token ?? null} />;
}
